module.exports = __webpack_public_path__ + "static/media/Gatwick-Ultralight.28ebf01f.otf";